module.exports = __webpack_public_path__ + "static/img/slide3.2c4d28a1.jpg";